import { styled, Link } from "@mui/material";

export const FooterContainer = styled("footer")(() => ({
  background: "var(--footer-bg-color)",  
  padding: "3rem 0",
  "@media (max-width: 40rem)": {
    padding: "2rem 0",
  },
  transition: "background-color 0.3s ease", 
}));

export const FooterWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  textAlign: "center",
  width: "90%",
}));

export const TextWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  "@media (max-width: 40rem)": {
    flexDirection: "column",
  },
}));

export const GithubLink = styled(Link)(() => ({
  color: "var(--footer-link-color)",  
  font: '300 1rem/1.7 "Poppins", sans-serif',
  fontSize: "1.6rem",
  fontWeight: "bold",
  textDecoration: "none",
  ":hover": {
    textDecoration: "underline",
  },
}));

export const LinkedinLink = styled(Link)(() => ({
  color: "var(--footer-link-color)",  
  font: '300 1rem/1.7 "Poppins", sans-serif',
  fontSize: "1.6rem",
  fontWeight: "bold",
  textDecoration: "none",
  ":hover": {
    textDecoration: "underline",
  },
}));

export const FooterText = styled("h3")(() => ({
  font: '500 1rem/1.7 "Poppins", sans-serif',
  fontSize: "1.7rem",
  fontWeight: "bold",
  letterSpacing: "0.02rem",
  color: "var(--footer-text-color)",  
}));


export const darkModeStyles = {
  "&.darkmode": {
    "--footer-bg-color": "#121212",  
    "--footer-text-color": "#ffffff", 
    "--footer-link-color": "#ffffff", 
  },
};
